import 'core-js/features/number/is-nan' // SwiperのIE対応
import 'custom-event-polyfill' // SwiperのIE対応
import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

if (document.getElementById('page-eat')) {
  pageSiteEat()
}
function pageSiteEat() {
  //   ####  ##      ##  ####    #####
  //  ##     ##      ##  ##  ##  ##
  //   ###   ##      ##  ##  ##  #####
  //     ##  ##      ##  ##  ##  ##
  //  ####   ######  ##  ####    #####

  if (document.getElementById('eatMv')) {
    // Swiperコンテナを検出したら実行
    // eslint-disable-next-line no-unused-vars
    const slideItem = document.getElementById('eatMv')
    const sliderName = 'eatMv'
    const eatMvSwiper = new Swiper(slideItem, {
      // init: false, // 自動で初期化しない（eatMvSwiper.init()で初期化）
      effect: 'slide', // slide,fade,cube,coverflow
      speed: 500, // アニメ速度
      // loop: true, // ループ
      // loopAdditionalSlides: 10, //ループ演出用のクローン数を増やして安定化させる
      preloadImages: false, // スライド内の画像を読み終えてから開始
      slidesPerView: 1, //表示数変更 小数指定可　'auto' + .swiper-slide{width:auto;}で可変化
      spaceBetween: 35, //スライド同士の間隔を空ける
      slideToClickedSlide: true, // クリックしたスライドをアクティブにする
      // centeredSlides: true, // 中央のスライドを基準にする
      // freeMode: true, //ドラッグ等でのスライド時、スライドが定位置以外で止まれるようにする
      // grabCursor: true, // 掴みカーソル
      // simulateTouch: false, // マウスドラッグでスワイプ操作　無効でテキスト選択が可能に
      touchRatio: 0.3, // タッチスワイプ感度（0でタッチスワイプ無効）

      // hashNavigation: {  //ステート変更 「data-hash」必須
      //   watchState: true,
      //   replaceState: true,
      // },
      pagination: {
        // ページャーオプション
        el: '.swiper-pagination--' + sliderName, // ページャーを呼び出す要素
        type: 'fraction', // bullets,fraction(現ページ/ページ数),progressbar,custom
      },
      navigation: {
        nextEl: '.swiper-button-next--' + sliderName, // 前のページボタンを呼び出す要素
        prevEl: '.swiper-button-prev--' + sliderName, // 次のページボタンを呼び出す要素
      },

      breakpoints: {
        // 指定px以上でオプション切り替え
        769: {
          touchRatio: 1, // タッチスワイプ感度（0でタッチスワイプ無効）
        },
      },
    })
  }
}
